import { useEffect } from 'react'

const useOnUnountEffect = (fn) => {
  useEffect(() => fn, [])
}

export default useOnUnountEffect
